/**
 * FAQ section: tab switching between metaobject-driven panels.
 */
(function () {
  function initRoot(root) {
    const tabs = Array.from(root.querySelectorAll('[data-faq-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-faq-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(handler) {
      tabs.forEach((tab) => {
        const isActive = tab.getAttribute('data-faq-tab') === handler;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-faq-panel') === handler;
        panel.hidden = !isActive;
        if (!isActive) {
          panel.querySelectorAll('details[open]').forEach((details) => {
            details.open = false;
          });
        }
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const handler = tab.getAttribute('data-faq-tab');
        if (!handler) return;
        activate(handler);
      });

      tab.addEventListener('keydown', (event) => {
        const index = tabs.indexOf(tab);
        let next = -1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        event.preventDefault();
        tabs[next].focus();
        activate(tabs[next].getAttribute('data-faq-tab'));
      });
    });

    const initial =
      tabs.find((tab) => tab.classList.contains('is-active') || tab.getAttribute('aria-selected') === 'true') ||
      tabs[0];
    if (initial) activate(initial.getAttribute('data-faq-tab'));
  }

  function init() {
    document.querySelectorAll('[data-faq-section]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
